// removed by extract-text-webpack-plugin
module.exports = {"loading":"onfido-sdk-ui-PhoneNumberInput-loading","mobileInput":"onfido-sdk-ui-PhoneNumberInput-mobileInput","phoneNumberContainer":"onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer","flagIcon":"onfido-sdk-ui-PhoneNumberInput-flagIcon"};


//////////////////
// WEBPACK FOOTER
// ./components/PhoneNumberInput/style.css
// module id = 226
// module chunks = 1